import { render, staticRenderFns } from "./baseModal.vue?vue&type=template&id=01f95fea"
import script from "./baseModal.vue?vue&type=script&lang=js"
export * from "./baseModal.vue?vue&type=script&lang=js"
import style0 from "./baseModal.vue?vue&type=style&index=0&id=01f95fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports